import React, { useState, useRef, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";
import GlobalSearch from "../pages/Searchglobal";

export default function Topbar({ sidebarOpen, setSidebarOpen, collapsed, setCollapsed, isNarrow: isNarrowProp }) {
  const [open, setOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  // Use prop if provided, else fall back to local state
  const [isNarrowLocal, setIsNarrowLocal] = useState(() => window.innerWidth <= 768);
  const isNarrow = isNarrowProp !== undefined ? isNarrowProp : isNarrowLocal;
  const [isVeryNarrow, setIsVeryNarrow] = useState(() => window.innerWidth <= 480);
  // Show search icon between 481px–768px (no inline search box)
  const showSearchIcon = isNarrow && !isVeryNarrow;
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const dropdownRef = useRef();
  const mobileSearchRef = useRef();
  const navigate = useNavigate();

  const isSidebarVisible = sidebarOpen !== undefined ? sidebarOpen : !collapsed;
  const toggleSidebar = () => {
    if (setSidebarOpen) setSidebarOpen((p) => !p);
    else if (setCollapsed) setCollapsed((p) => !p);
  };

  useEffect(() => {
    const onResize = () => {
      setIsNarrowLocal(window.innerWidth <= 768);
      setIsVeryNarrow(window.innerWidth <= 480);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
      if (mobileSearchRef.current && !mobileSearchRef.current.contains(e.target)) {
        setMobileSearchOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
        .then(() => setIsFullscreen(true))
        .catch((err) => console.error(err));
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/", { replace: true });
  };

  return (
    <header className="topbar">

      {/* ── LEFT ── */}
      <div className="topbar-left">
        {/* Hamburger — only when sidebar hidden on narrow */}
        {isNarrow && !isSidebarVisible && (
          <i className="bi bi-list topbar-hamburger" onClick={toggleSidebar} />
        )}

        {/* GlobalSearch — only on > 480px */}
        {!isVeryNarrow && (
          <GlobalSearch narrowMode={isNarrow} />
        )}

        {/* Very narrow (≤480px): nothing here — hamburger only */}
      </div>

      {/* ── RIGHT ── */}
      <div className="topbar-right">

        {(isNarrow) && (
          <i
            className="bi bi-search topbar-icon"
            style={{ cursor: "pointer" }}
            onClick={() => setMobileSearchOpen((p) => !p)}
          />
        )}

        {/* Moon */}
        <i className="bi bi-moon topbar-icon" />

        
        {!isVeryNarrow && (
          <i
            className="bi bi-arrows-fullscreen topbar-icon"
            onClick={toggleFullscreen}
          />
        )}

        {/* Admin */}
        <div className="topbar-admin-wrap" ref={dropdownRef}>
          <CustomButton
            as="div"
            className="topbar-user"
            onClick={() => setOpen((p) => !p)}
          >
            <span className="user-name" style={{ cursor: "pointer" }}>Admin</span>
          </CustomButton>

          {open && (
            <div className="custom-dropdown-menu">
              <div className="custom-dropdown-item" onClick={() => navigate("/reportreasons")}>
                <i className="bi bi-person" /> Settings
              </div>
              <div className="custom-dropdown-item" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right" /> Logout
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── MOBILE SEARCH OVERLAY (drops below topbar when 🔍 tapped) ── */}
      {mobileSearchOpen && (
        <div className="topbar-mobile-search" ref={mobileSearchRef}>
          <GlobalSearch autoFocus narrowMode={false} />
        </div>
      )}

    </header>
  );
}
